import angular from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { MachineConfigurationView } from "../../models/machineConfiguration";
import { vsComponentName as MachinesChangeViewComponentOptionsName } from "./component";
import { IReportGroup } from "../../../../reporting/interfaces/IReportGroup";

export const vsServiceName = "MachinesChangeViewModalService";

export interface MachinesChangeViewModalOptions {}

export class MachinesChangeViewModalService {
  static $inject = ["$uibModal"];
  constructor(private readonly $uibModal: angular.ui.bootstrap.IModalService) {}

  openModal(ChangeId: string, reportGroup: IReportGroup) {
    var popup = this.$uibModal.open({
      component: MachinesChangeViewComponentOptionsName,
      resolve: {
        machineConfigurations: [
          ServerUtilityName,
          (serverUtility: ServerUtility) =>
            serverUtility.fetchAll<MachineConfigurationView>({
              url: "/api/machines/MachineConfiguration",
              query: { ChangeId },
            }),
        ],
        ChangeId: () => ChangeId,
        reportGroup: [() => reportGroup],
      },
    });

    return popup;
  }
}
